// extracted by mini-css-extract-plugin
export default {"RandomButton":"RandomMovieButton_RandomButton__6cuj6"};